import React from "react";
import { Dispatcher, BookStore } from "../../flux";

import ReviewContainer from "./review-mode";

const ReviewModeChrome = ({ children, highlights, isbn }) => {
  const _exitReviewMode = () => {
    const book = BookStore.get(isbn);
    book.viewer.Book.focusHighlight();
    Dispatcher.emit(Dispatcher.CHANGE_CHROME, "");
    Fraction.Helpers.focusOnElement(".launch-review-mode-button");
  };

  var zIndexRight = {};
  var zIndexLeft = {};
  if (
    Fraction.Helpers.isSmallScreen() &&
    (!Fraction.TourQueue || Fraction.TourQueue.length === 0)
  ) {
    zIndexRight = { zIndex: 5 };
    zIndexLeft = { zIndex: 1 };
  }
  return (
    <div id="review-mode-chrome">
      <div className="review-mode-header">
        <h2 className="focus-title">{i18n.t("review-mode.review")}</h2>
        <button className="noButton" onClick={_exitReviewMode}>
          {i18n.t("base.exit")}
        </button>
      </div>
      <div
        style={zIndexLeft}
        className="review-mode-side review-mode-left"
        role="main"
        aria-label={i18n.t("review-mode.book-view")}
      >
        {children}
      </div>
      <div
        style={zIndexRight}
        className="review-mode-side review-mode-right"
        role="complementary"
        aria-label={i18n.t("review-mode.review-panel")}
      >
        <ReviewContainer isbn={isbn} highlights={highlights} />
      </div>
    </div>
  );
};

module.exports = {
  class: ReviewModeChrome,
  metadata: () => {
    return {
      id: "review-mode-chrome",
      name: i18n.t("scratchpad.scratchpad"),
      description: i18n.t("scratchpad.description"),
      type: "chrome"
    };
  }
};
